export default {
    doctor: 'زبون تجزئة',
    'doctorVisits': 'زيارات زبون التجزئة', 
    doctors: 'زباين التجزئة',
    pharmacy: 'زبون جملة',
    pharmacies: 'زباين الجملة',
    center: 'المركز',
    centers: 'المراكز ',
    'pharmacyVisits': 'زيارات زبون الجملة',
    centerVisits: 'زيارات المراكز ',
    'medicalRep': 'المندوب',
    'doctorName': 'اسم زبون التجزئة',
    'doctorHobbies': 'هوايات زبون التجزئة',
    'editDoctor': 'تعديل زبون ',
    'deleteDoctor': 'حذف زبون التجزئة',
    'centerNotes': 'ملاحظات المركز ',
    'pharmaceuticalForms': 'الأشكال',
    'pillsPerBox': 'عدد القطع في الصندوق',
    'medRepPlan': 'خطة مندوب',
    'medRepZone': 'منطقة المندوب',
    'medRepMark': 'تواتر زيارات المندوب',
    'addNewDoctor': 'إضافة زبون جديد',
}